import { meteorCall } from '/imports/utils';

export type MethodDeclaration<A, R = undefined> = {
  name: string,
  call: (arg: A) => Promise<R>
}

export const DeclareMethod = <A, R = undefined>(name: string): MethodDeclaration<A, R> => {
  return {
    name,
    call: async (arg: A) => {
      return (await meteorCall(name, arg)) as R;
    },
  } as MethodDeclaration<A, R>;
};